export const MEMORY_SIZES = ['128MB', '256MB', '512MB', '1G', '2G', '4G', '8G', '16G'];
export const ITEM_SIZE = [
  '2S',
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  '2XL',
  'XXL',
  '3XL',
  'XXXL',
  '4XL',
  'XXXXL',
  '5XL',
  'XXXXL',
];
export const SIZES = [...ITEM_SIZE, ...ITEM_SIZE.map((e) => `${e} T`), ...MEMORY_SIZES];
const onlyLastmatch = (size) => {
  const s = size.split('-');
  if (s.length > 1) {
    const lastMatch = s.pop();
    return [s.join('-'), lastMatch];
  }

  return s;
};
export const findQuerySize = (query, part) => {
  if (!query.part && query.sizes) {
    if (!Array.isArray(query.sizes)) query.sizes = [query.sizes];
    query.part = query.sizes.map((size) => [query.partId, ...onlyLastmatch(size)].join('_'));
  }
  if (part.ApparelSize && part.ApparelSize.label_size && query.part) {
    try {
      if (!Array.isArray(query.part)) query.part = [query.part];
      const mapped = query.part.map((e) => {
        const s = e.split('_');
        const quantity = s.pop();
        const size = s.pop();
        const partId = s.join('_');
        return { [partId]: parseInt(quantity) };
      });
      return mapped.find((e) => e[part.partId]);
    } catch (e) {}
  }
};
export const checkQuerySize = (query, part) => {
  let quantity = null;
  const size = findQuerySize(query, part);
  if (size) {
    quantity = size[part.partId] || 1;
  }
  return quantity;
};
